import { UserAction, UserState } from "./types";

export const setUserInfo = (payload: Partial<UserState>) =>
  ({
    type: UserAction.SET_USER_DATA,
    payload,
  }) as const;

export const cleanUpUser = () =>
  ({
    type: UserAction.CLEAN_UP,
  }) as const;

export const submitTicket = (payload = {}, callBack = () => {}) =>
  ({
    type: UserAction.SUBMIT_TICKET,
    payload,
    callBack,
  }) as const;

export const getContractRecords = (payload = {}) =>
  ({
    type: UserAction.GET_CONTRACT_RECORDS,
    payload,
  }) as const;

export const getPendingContractRecords = (payload = {}) =>
  ({
    type: UserAction.GET_PENDING_CONTRACT_RECORDS,
    payload,
  }) as const;

export const getClaims = (payload = {}) =>
  ({
    type: UserAction.GET_CLAIMS,
    payload,
  }) as const;

export const getSKUOptions = (payload = {}) =>
  ({
    type: UserAction.GET_SKUsOPTIONS,
    payload,
  }) as const;

export const setContractRecords = (payload) =>
  ({
    type: UserAction.SET_CONTRACT_RECORDS,
    payload,
  }) as const;

export const setPendingContractRecords = (payload) =>
  ({
    type: UserAction.SET_PENDING_CONTRACT_RECORDS,
    payload,
  }) as const;

export const setClaims = (payload) =>
  ({
    type: UserAction.SET_CLAIMS,
    payload,
  }) as const;

export const setSkus = (payload) =>
  ({
    type: UserAction.SET_SKUsOPTIONS,
    payload,
  }) as const;
